export default "__VITE_ASSET__TD1rEVtS__"